import React, { Fragment } from 'react';
import './isi.scss';
import IsiSection from './IsiSection';
import { isiData } from './isiData';
import Hyperlink from '../Hyperlink/Hyperlink';

function IsiBody({ origin }) {
  const hyperlinkData = [
    {
      origin: '',
      href: 'https://www.janssenlabels.com/package-insert/product-monograph/prescribing-information/SPRAVATO-pi.pdf',
      a: 'Prescribing Information'
    },
    {
      origin: '',
      href: 'https://www.janssenlabels.com/package-insert/product-patient-information/SPRAVATO-medication-guide.pdf',
      a: 'Medication Guide'
    },
    {
      origin: '',
      href: 'https://www.spravato.com/?utm_source=CNN&utm_medium=Article&utm_campaign=SPR_SponCon&utm_id=Patient_Article',
      a: 'www.spravato.com'
    }
  ];
  return (
    <section className={`isi__body isi__body-${origin}`}>
      <h4 className="isi__body__bold">INDICATIONS</h4>
      {Array.from(Array(4), (e, i) => {
        return <IsiSection index={i} key={`isisection-${i}`} />;
      })}

      <h4 className="isi__body__bold">IMPORTANT SAFETY INFORMATION</h4>
      <div className="isi__body--box">
        <h5 className="isi__body__bold">
          What is the most important information I should know about SPRAVATO®?
        </h5>
        <IsiSection index={4} box={true} />
      </div>
      {Array.from(Array(isiData.length), (e, i) => {
        return <Fragment key={`isisection-${i}`}>{i > 4 && <IsiSection index={i} />}</Fragment>;
      })}
      <p className="isi__body__bold">
        Please see full <Hyperlink hyperlinkData={hyperlinkData[0]} />, including Boxed WARNINGS,
        and <Hyperlink hyperlinkData={hyperlinkData[1]} /> for SPRAVATO® and discuss any questions
        you may have with your healthcare provider.
      </p>
      <p className="isi__body__text">cp-170363v3</p>
      {origin === 'bottom' && (
        <p className="isi__body__bold">
          For more information about SPRAVATO®, please visit{' '}
          <Hyperlink hyperlinkData={hyperlinkData[2]} />.
        </p>
      )}
      <p className="isi__body__bold">
        This information is intended for the use of patients and caregivers in the United States and
        its territories only. Laws, regulatory requirements and medical practices for pharmaceutical
        products vary from country to country. The Prescribing Information included here may not be
        appropriate for use outside the United States and its territories.
      </p>
    </section>
  );
}

export default IsiBody;
